// extracted by mini-css-extract-plugin
export default {"row":"EventOfferGreaterNumberTickets_row__AXWQw","wrapper":"EventOfferGreaterNumberTickets_wrapper__Bs3cF","item":"EventOfferGreaterNumberTickets_item__JvopS"};